import { observer } from 'mobx-react-lite'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { View, Text, StyleSheet } from 'react-native'
import { Spacer } from '../../../ui/atoms'
import { Col } from '../../../ui/atoms/Grid'
import { Carousel } from '../../../ui/molecules'
import CreditStore from './CreditStore'
import { PayNowWithVirtualCard } from './PayNowWithVirtualCard'

interface Props {
  spacer?: number
  mobileView?: boolean
  dontShowExpired?: boolean
  asCarousel?: boolean
  asDesktopCards?: boolean
}

export const VirtualCardListing = observer(
  ({
    spacer = 0,
    mobileView = false,
    dontShowExpired = false,
    asCarousel = false,
    asDesktopCards = false,
  }: Props) => {
    const { loansWithUnusedCards, isExpired, unusedActiveCards } = CreditStore
    const { t } = useTranslation('global')
    const cardStyle = asDesktopCards ? { marginVertical: 20 } : null

    const getListItem = (item, style?, singleCard?) => {
      if (dontShowExpired && isExpired(item.card?.status)) return null
      else
        return (
          <View style={style}>
            <PayNowWithVirtualCard
              data={item}
              mobileView={mobileView}
              style={singleCard && { alignSelf: 'stretch', marginBottom: 20 }}
            />
            {!!spacer && <Spacer height={spacer} />}
          </View>
        )
    }

    if (asCarousel) {
      if (unusedActiveCards.length > 1)
        return (
          <View style={styles.mobileSection}>
            <Text style={styles.mobileSectionTitle}>
              {t('PayNowWithVirtualCard.title')}
            </Text>
            <Carousel>
              {loansWithUnusedCards.map((l) => {
                return getListItem(l, cardStyle)
              })}
            </Carousel>
          </View>
        )
    }

    if (asDesktopCards && unusedActiveCards.length > 1) {
      return (
        <>
          {loansWithUnusedCards.map((l) => {
            const listItem = getListItem(l, cardStyle)
            return listItem ? (
              <Col xs={12} sm={12} md={6} xl={6}>
                {listItem}
              </Col>
            ) : null
          })}
        </>
      )
    }

    if (!asDesktopCards && !asCarousel) {
      return (
        <>
          {loansWithUnusedCards.map((l) => {
            return getListItem(l, cardStyle)
          })}
        </>
      )
    }

    return (
      <Col xs={12} sm={12} md={12} xl={6}>
        {loansWithUnusedCards.map((l) => {
          return getListItem(l, cardStyle, true)
        })}
      </Col>
    )
  },
)

const styles = StyleSheet.create({
  mobileSection: {
    backgroundColor: '#F8F9F9',
    height: 250,
    paddingLeft: 20,
    paddingVertical: 17,
    marginHorizontal: -16,
    marginVertical: 10,
  },
  mobileSectionTitle: {
    fontWeight: '700',
    fontSize: 18,
    lineHeight: 24,
    color: '#003353',
    marginBottom: 16,
  },
})
